import './styles.scss'

import React from 'react'

import I18n from 'lib/i18n'

import satisfactionIcon from '../_assets/satisfaction-icon.svg'

const GoodFitModalContent = () => (
  <div className='good-fit-modal-content-container'>
    <div className='good-fit-title'>{I18n.t('bookings.good_fit.title')}</div>
    <div className='good-fit-logo-container'>
      <img className='goot-fit-logo' alt='goot fit logo' src={`${satisfactionIcon}`} width={152} height={93} />
    </div>
    <div className='good-fit-text'>{I18n.t('bookings.good_fit.line_1')}</div>
  </div>
)

export default GoodFitModalContent
